<div class="text_box">
  <h2>계정 영구 삭제</h2><hr>
  <p>회원님의 계정은 사이트에서 비활성화되었으며 <span>14일 이내에 영구 삭제</span>될 예정입니다.<br>14일 이내에 계정 활성화를 하면 삭제 요청이 취소되고 계정이 활성화 됩니다.</p>
  <div style="text-align: right;">
    <button mat-flat-button (click)="reactivateAccount()" color="warn">계정 활성화</button>
  </div>
</div>  
<div class="body_bg"></div>
